import styled from 'styled-components';
import {Divider, Select, Space} from 'antd';
import Search from '../../../Search';

const StyledTableFilters = styled(Space)`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  overflow: auto hidden;
`;

const StyledTableFiltersCardSelect = styled(Select)`
  min-width: 190px;

  &.ant-select-lg {
    .ant-select-selector {
      &::after {
        line-height: 30px;
      }
    }
  }

  .ant-select-selection-item-content {
    & > .ant-space {
      & > .ant-space-item {
        &:nth-of-type(1) {
          display: none;
        }
      }
    }
  }
`;

const StyledTableFiltersDivider = styled(Divider)`
  height: 32px;
  top: 0;
`;

const StyledTableFiltersSearch = styled(Search)`
  width: 168px;
`;

export {
  StyledTableFilters,
  StyledTableFiltersCardSelect,
  StyledTableFiltersDivider,
  StyledTableFiltersSearch,
};
